import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function VendorPayouts() {
  const [payouts, setPayouts] = useState([]);
  useEffect(() => { api.get("/vendor/payouts").then(r => setPayouts(r.data)); }, []);

  const pending = payouts.filter(p => p.status === "pending").reduce((s, p) => s + p.net, 0);
  const paid = payouts.filter(p => p.status === "paid").reduce((s, p) => s + p.net, 0);

  return (
    <div>
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Wallet</p>
      <h1 className="font-serif text-6xl mt-2 mb-10 tracking-tighter">Payouts.</h1>

      <div className="grid md:grid-cols-3 gap-4 mb-10">
        <div className="border-2 border-[hsl(var(--accent))] p-6 tag-punch pl-12">
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Pending</p>
          <p className="font-serif text-4xl mt-2 text-[hsl(var(--accent))]">₹ {pending.toLocaleString("en-IN")}</p>
          <p className="font-mono text-[11px] text-muted-foreground mt-2">Cleared for next payout cycle</p>
        </div>
        <div className="border border-foreground p-6">
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Lifetime Paid</p>
          <p className="font-serif text-4xl mt-2">₹ {paid.toLocaleString("en-IN")}</p>
          <p className="font-mono text-[11px] text-muted-foreground mt-2">Since account opened</p>
        </div>
        <div className="border border-foreground p-6">
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Commission</p>
          <p className="font-serif text-4xl mt-2">12%</p>
          <p className="font-mono text-[11px] text-muted-foreground mt-2">Standard house terms</p>
        </div>
      </div>

      <h2 className="font-serif text-3xl mb-4">History</h2>
      {payouts.length === 0 ? (
        <p className="text-muted-foreground text-sm">No payouts yet — admin creates payout entries at end of each cycle.</p>
      ) : (
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead>
            <tr className="border-b border-foreground font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="text-left py-2">Period</th><th className="text-left">Gross</th><th className="text-left">Commission</th><th className="text-left">Net</th><th className="text-left">Status</th><th className="text-left">Paid At</th>
            </tr>
          </thead>
          <tbody>
            {payouts.map(p => (
              <tr key={p.id} className="border-b border-foreground/20">
                <td className="py-3 font-mono text-xs">{p.period_start} → {p.period_end}</td>
                <td className="font-mono">₹ {p.gross.toLocaleString("en-IN")}</td>
                <td className="font-mono text-muted-foreground">₹ {p.commission.toLocaleString("en-IN")}</td>
                <td className="font-mono font-semibold">₹ {p.net.toLocaleString("en-IN")}</td>
                <td><span className={`font-mono text-[10px] uppercase px-2 py-1 border ${p.status === "paid" ? "border-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "border-foreground/40"}`}>{p.status}</span></td>
                <td className="font-mono text-xs">{p.paid_at ? new Date(p.paid_at).toLocaleDateString("en-IN") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}
